<template>
  <div class="cardR">
    <div class="boxR">
      <div class="modal-content filterHolder mdl mdbox" v-show="settingPopShow">
        <div class="modal-header">
          <h5 class="modal-title">Settings</h5>
          <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
            v-on:click="settingPopShow = !settingPopShow;">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body">
          <div class="col-12 filterModbx">
            <label>Select Filter Groupby : </label>
            <div class="row">
              <div class="col-6">
                <div class="row g-0 align-items-stretch mb-3" v-for="(addFilters, index) in pivotviewlevel"
                  :key="addFilters">
                  <div class="col-10">
                    <div class="input-group  pe-1">
                      <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="addFilters.filterval"
                        selectLabel="" :options="getdropsdata" :multiple="false" :allow-empty="false"
                        deselect-label="can't Deselect" :close-on-select="true" @select="loadSplit" placeholder="Pick"
                        track-by="dbname" label="name" />
                    </div>
                  </div>
                  <div class="col-1 text-center">
                    <button class="btn minusBtn" v-on:click="modifylevel(index, 0)" :disabled="index == 0"
                      title="click to remove filter" v-show="pivotviewlevel.length == index + 1">
                      <font-awesome-icon :icon="['fas', 'minus']" />
                    </button>
                  </div>
                  <div class="col-1 text-center">
                    <button class="btn addBtn" v-on:click="modifylevel(index, 1)" :disabled="!pivotviewlevel.length"
                      title="click to add filter" v-show="pivotviewlevel.length == index + 1">
                      <font-awesome-icon :icon="['fa', 'plus']" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <label>Select Filter Splitby : </label>
                <div class="input-group myMarginTop col-6" style="float:right;">
                  <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="spliton" :options="splitOps"
                    :multiple="false" :allow-empty="false" deselect-label="can't Deselect" :close-on-select="true"
                    placeholder="Pick" track-by="dbname" label="name" selectLabel="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="effect btn-apply eff-md" v-on:click="getPivot(1); settingPopShow = !settingPopShow;">
            Apply
          </div>
        </div>
      </div>
      <div class="fc myZoomClass" id="pivotchartsnap">
        <div class="content-panel1" v-show="IspivotviewErr">
          <div class="insideL  hide-on-presentation ">
            <div class="icon">
              <font-awesome-icon icon="fa-solid fa-bars" />
            </div>
            <div class="contents">
              <span>
                <font-awesome-icon icon="fa-solid fa-cog" title="Open Settings" v-on:click="showSettingsFunc()" />
              </span>
            </div>
          </div>
          <apiErrorComponent @tryReload="tryReload" compTitle="" compId="pivotchartsnap"></apiErrorComponent>
        </div>
        <div id="pivoteChartFancyChartDiv" v-show="!IspivotviewErr">
          <div class="content-panel1">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span>
                  <font-awesome-icon icon="fa-solid fa-cog" title="Open Settings" v-on:click="showSettingsFunc()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.cust_pivot }} <br />
                <br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-cog" /> to open settings
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to add to storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to download the chart with
                    current insight
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isPivotLoaded">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isPivotLoaded" class="settingDiv"></div>
            <div v-show="settingPopShow" class="settingDiv"></div>
            <div class="row">
              <div class="col-10">
                <h2 class="chartTitle hide-on-presentation themeclr2">{{ fancyChartName }}</h2>
              </div>
              <div class="col-2">
                <font-awesome-icon icon="fa-solid fa-cog" title="Open Settings" class="myfaBtn cursor-pointer"
                  v-on:click="settingPopShow = !settingPopShow;" />
              </div>
            </div>
            <div class="panel-body text-center panelbodyDiy " id="myPanelFCBody">
              <div>
                <div class="pivot-table-container">
                  <tree-table class="pivote-table pvtHt" :columns="columns" :table-data="tableData"
                    :style="'width: ' + columns.length * 200 + 'px'">
                    <template #headerTemplate="headerProps">
                      <SortingHeader v-bind="headerProps" :sort-table="sortTable" />
                    </template>
                  </tree-table>
                </div>
              </div>
              <div v-if="ispivotviewData" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  reactive
} from "vue";
import {
  useRoute
} from 'vue-router';
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import domtoimage from "dom-to-image-more";
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue';
import TreeTable from 'vue-tree-table-component';
import SortingHeader from "../smallcomp/SortingHeader";
import sortData from "../smallcomp/sortData";
import {
  saveAs
} from 'file-saver';
export default {
  name: 'PivotChart',
  mixins: [screenShotMix],
  props: {
    getPins: Object,
    getDrops: Array,
    tabname: String,
  },
  components: {
    widgetDataMsg,
    widgetLoadingComp,
    apiErrorComponent,
    TreeTable,
    SortingHeader
  },
  data() {
    return {
      IspivotviewErr: false,
      ispivotviewData: false,
      isPivotLoaded: false,
      fancyChartName: "",
      spliton: "",
      splitOps: [],
      pivotviewlevel: [],
      settingPopShow: false,
      getdropsdata: this.getDrops,
      isReadOnlyView: true,
      TClrs: '',
      columns: [],
      tableData: []
    }
  },
  methods: {
    sortTable(params) {
      sortData(this.tableData, params)
    },
    tryReload() {
      this.getPivot()
    },
    addToSlider() {
      let insArr = this.mttrinsight;
      let name = "Pivot - " + this.getPins.viewName;
      let screenShort = {
        id: 'pivoteChartFancyChartDiv',
        name: 'pivoteChartFancyChartDiv.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    downloadDom() {
      let imgname = "Pivot_Chart.png"
      let widgetID = "pivoteChartFancyChartDiv"
      var geticondiv = document.querySelectorAll(
        '#pivoteChartFancyChartDiv .insideL,#pivoteChartFancyChartDiv .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 0;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    modifylevel(pos, vals) {
      if (vals == 0) {
        this.pivotviewlevel.splice(pos, 1);
      } else {
        if (pos < 4) {
          this.pivotviewlevel.push({
            filterval: {
              dbname: ""
            }
          });
        } else {
          this.$notify({
            type: "error",
            text: 'Sorry! Filter limit Reached!'
          })
        }
      }
    },
    showSettingsFunc() {
      this.settingPopShow = true;
    },
    loadSplit(catop) {
      var splitObjs = []
      for (var i = 0; i < this.getdropsdata.length; i++) {
        splitObjs.push({
          dbname: this.getdropsdata[i].dbname,
          name: this.getdropsdata[i].name,
        });
      }
      if (catop.dbname.length != 0) {
        this.splitOps = splitObjs
        var pos = -1
        for (var j = 0; j < this.splitOps.length; j++) {
          if (this.splitOps[j].dbname.toUpperCase() === catop.dbname.toUpperCase()) {
            pos = j
            break
          }
        }
        let position = pos
        if (position > -1) {
          this.splitOps.splice(position, 1)
        }
      } else {
        this.splitOps = catop.dbname
      }
    },
    checkDuplicate(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (this.spliton.dbname != undefined) {
          if (arr[i].filterval.dbname === this.spliton.dbname) {
            return true
          }
        }
        for (let j = 1; j < arr.length; j++) {
          if (i !== j) {
            if (arr[i].filterval.dbname == arr[j].filterval.dbname) {
              return true
            }
          }
        }
      }
      return false
    },
    getPivot(isfilter) {
      var dupsChk
      let optsAll = []
      if (isfilter == 1) {
        if (this.spliton == "") {
          this.$notify({
            type: "warn",
            text: 'Sorry! Filter Split by cannot be empty!'
          })
        } else {
          dupsChk = this.checkDuplicate(this.pivotviewlevel)
        }
        optsAll = this.pivotviewlevel.map(item => ({
          opts: item.filterval.dbname
        }))
      }
      if (dupsChk == true) {
        this.$notify({
          type: "warn",
          text: 'Sorry! Filter values cannot contain Same values. Try with different filters!'
        })
      } else {
        this.IspivotviewErr = false
        this.ispivotviewData = false
        this.isPivotLoaded = false
        this.fancyChartName = "Pivot View"
        this.axios.post(this.uriApiUrl + 'DataAnalysis/custom_pivotview?asg_id=' + this.asgId, {
          "filterlevel": this.pivotviewlevel,
          "splitby": this.spliton,
          "selid": this.getPins.selid,
          "edited": this.getPins.edited
        },{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            if (response.status == 200) {
              if (response.data == "Error") {
                this.IspivotviewErr = true
                this.$notify({
                  type: "error",
                  text: 'Sorry! Something went wrong in Custom Tree view. Try after sometime!'
                })
              } else {
                var respdata = response.data.cuspivotdata
                if (respdata != "Error" && respdata != "Nodata") {
                  var pivotWholedata = response.data
                  this.pivotviewlevel = []
                  this.settingPopShow = false
                  for (let index = 0; index < pivotWholedata.filterlvl.length; index++) {
                    this.pivotviewlevel.push({
                      filterval: pivotWholedata.filterlvl[index]
                    })
                  }
                  let i = 0
                  while (i < this.pivotviewlevel.length) {
                    this.loadSplit(this.pivotviewlevel[i].filterval)
                    i++
                  }
                  if (typeof pivotWholedata.splitby[0] == Array) {
                    this.spliton = pivotWholedata.splitby[0]
                  } else {
                    this.spliton = pivotWholedata.splitby
                  }
                  var pivotchart = pivotWholedata.cuspivotdata.pivotcht
                  var tableData = []
                  for (let index = 0; index < respdata.pivottable.tbldata.length; index++) {
                    const element = respdata.pivottable.tbldata[index];
                    if (element["Business Function"] != "") {
                      tableData.push(element);
                    }
                  }
                  this.tableData = tableData
                  this.columns = respdata.pivottable.heads
                  if (isfilter == 1) {
                    this.settingPopShow = !this.settingPopShow
                  }
                } else if (respdata == "Nodata") {
                  this.ispivotviewData = true
                } else {
                  this.IspivotviewErr = true
                  this.$notify({
                    type: "error",
                    text: 'Sorry! Something went wrong in Custom Pivot view. Try after sometime!'
                  })
                }
              }
            }
            this.isPivotLoaded = true
          }).catch((response) => {
            this.IspivotviewErr = true
            this.isPivotLoaded = true
            if (this.enabledDebug == 1) {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Custom Pivot view. Try after sometime!'
              })
            }
          })
      }
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getPivot()
  },
  computed: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filterHolder {
  z-index: 30;
  width: 80%;
  left: 10%;
  top: 35px;
}

.filterModbx .btn {
  height: 100%;
  padding: initial;
  padding-left: 10px;
  padding-right: 10px;
}

.pivot-table-container {
  overflow: auto;
  position: relative;
  top: 0;
  left: 0;
}

.pvtHt {
  max-height: 370px;
  padding: 0 12px;
}

.content-panel {
  position: absolute;
}

.pivote-table.pvtHt .row .cell {
  text-align: left;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>